import { render } from "./Status.vue?vue&type=template&id=2f50bdf2&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"

import "./Status.vue?vue&type=style&index=0&id=2f50bdf2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rightcom-spa/rightcom-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f50bdf2"]])

export default __exports__